export default __webpack_public_path__ + "static/media/og.2e0c25a5.png";